import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../../../context/spinnerContext'
import { errorToast, successToast } from '../../../../util/Toast/toast'
import { editCleanerServiceValue } from '../../../../redux/slices/propertySlice'
import { cleanerServiceValueSchema } from '../../../../util/validationSchema'

const EditCleanerServiceValue = ({ propertyId, setIsRefresh, toggleCleanerServiceValueModal, propertyData }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, control, trigger } = useForm({
    resolver: yupResolver(cleanerServiceValueSchema),
    defaultValues: { cleaner_service_value: propertyData?.cleaner_service_value }
  })

  const onSubmit = (data) => {
    const payload = {
      property_id: propertyId,
      data: data
    }
    setIsRefresh(false)
    changeLoader(true)
    if (propertyId) {
      dispatch(editCleanerServiceValue(payload)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          toggleCleanerServiceValueModal()
          setIsRefresh(true)
          changeLoader(false)
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group w-100 input_with_icon position-relative">
              <label>
                Cleaner Service Value<span className="text-danger"> *</span>
              </label>
              <Controller
                name="cleaner_service_value"
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <input
                      className="form-control"
                      value={value ? value : ''}
                      type="number"
                      placeholder="Enter Cleaner Service Value"
                      onChange={(val) => {
                        onChange(val)
                        trigger('cleaner_service_value')
                      }}
                    />
                    <span className="info_box_div" style={{ top: '55px', right: '10px' }}>
                      <span>$</span>
                    </span>
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => toggleCleanerServiceValueModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Update`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default EditCleanerServiceValue
